module.exports = __webpack_public_path__ + "static/fonts/PingFang-SC-Semibold.e9ad33e.otf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/PingFang-SC-Semibold.otf
// module id = F8MD
// module chunks = 1